export default __webpack_public_path__ + "static/pic03-664e0cb30018f6b32a70cf6c837bbfea.jpg";